import React, { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const IconTwitter = memo(
  forwardRef((props, ref) => (
    <SvgIcon {...props} ref={ref} viewBox="0 0 30 30" data-fill-none>
      <path
        d="M27 7.5585C26.1075 7.95 25.1565 8.2095 24.165 8.3355C25.185 7.7265 25.9635 6.7695 26.3295 5.616C25.3785 6.183 24.3285 6.5835 23.2095 6.807C22.3065 5.8455 21.0195 5.25 19.6155 5.25C16.8915 5.25 14.6985 7.461 14.6985 10.1715C14.6985 10.5615 14.7315 10.9365 14.8125 11.2935C10.722 11.094 7.1025 9.1335 4.671 6.147C4.2465 6.8835 3.9975 7.7265 3.9975 8.634C3.9975 10.338 4.875 11.8485 6.183 12.723C5.3925 12.708 4.617 12.4785 3.96 12.117C3.96 12.132 3.96 12.1515 3.96 12.171C3.96 14.562 5.6655 16.548 7.902 17.0055C7.5015 17.115 7.065 17.1675 6.612 17.1675C6.297 17.1675 5.979 17.1495 5.6805 17.0835C6.318 19.032 8.127 20.4645 10.278 20.511C8.604 21.8205 6.4785 22.6095 4.1775 22.6095C3.774 22.6095 3.387 22.5915 3 22.542C5.1795 23.9475 7.7625 24.75 10.548 24.75C19.602 24.75 24.552 17.25 24.552 10.749C24.552 10.5315 24.5445 10.3215 24.534 10.113C25.5105 9.42 26.331 8.5545 27 7.5585Z"
        fill="#03A9F4"
      />
    </SvgIcon>
  ))
);
